import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import CustomFormatDatePicker from "../../../components/CustomFormatDatePicker";

export const EditVehicleRate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [pricingProfileId, setPricingProfileId] = useState("");
    const [vehicleTypeId, setVehicleTypeId] = useState("");
    const [seasonId, setSeasonId] = useState("");
    const [rateUnitId, setRateUnitId] = useState("");

    const [amount, setAmount] = useState("");
    const [minimumQuantity, setMinimumQuantity] = useState("");
    const [maximumQuantity, setMaximumQuantity] = useState("");
    const [priority, setPriority] = useState("0");

    const [effectiveFrom, setEffectiveFrom] = useState("");
    const [effectiveTo, setEffectiveTo] = useState("");

    const [enabled, setEnabled] = useState("No");

    const [pricingProfiles, setPricingProfiles] = useState<any[]>([]);
    const [vehicleTypes, setVehicleTypes] = useState<any[]>([]);
    const [seasons, setSeasons] = useState<any[]>([]);
    const [rateUnits, setRateUnits] = useState<any[]>([]);

    const [pleaseWaitPopup, setPleaseWaitPopup] = useState(false);

    useEffect(() => {
        axios.get(`${baseURL}pricing-profiles/`).then((res) => {
            const data = res.data.data || [];
            setPricingProfiles(data);
            if (data.length) setPricingProfileId(String(data[0].id));
        });

        axios.get(`${baseURL}vehicle-types/`).then((res) => {
            const data = res.data.data || [];
            setVehicleTypes(data);
            if (data.length) setVehicleTypeId(String(data[0].id));
        });

        axios.get(`${baseURL}seasons/`).then((res) => {
            setSeasons(res.data.data || []);
        });

        axios.get(`${baseURL}rate-units/`).then((res) => {
            const data = res.data.data || [];
            setRateUnits(data);
            if (data.length) setRateUnitId(String(data[0].id));
        });
    }, []);

    useEffect(() => {
        axios
            .get(`${baseURL}vehicle-rates/${location.state}`)
            .then((res) => {
                const rate = res.data.data;

                setPricingProfileId(String(rate.pricing_profile_id));
                setVehicleTypeId(String(rate.vehicle_type_id));
                setSeasonId(rate.season_id ? String(rate.season_id) : "");
                setRateUnitId(String(rate.rate_unit_id));

                setAmount(String(rate.amount));
                setMinimumQuantity(
                    rate.minimum_quantity
                        ? String(rate.minimum_quantity)
                        : ""
                );

                setMaximumQuantity(
                    rate.maximum_quantity
                        ? String(rate.maximum_quantity)
                        : ""
                );

                setPriority(String(rate.priority));

                setEffectiveFrom((rate.effective_from));
                setEffectiveTo((rate.effective_to));

                setEnabled(rate.is_active ? "Yes" : "No");
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        const payload = {
            pricing_profile_id: Number(pricingProfileId),
            vehicle_type_id: Number(vehicleTypeId),
            season_id: seasonId ? Number(seasonId) : null,
            rate_unit_id: Number(rateUnitId),

            amount: Number(amount),

            minimum_quantity: minimumQuantity
                ? Number(minimumQuantity)
                : null,

            maximum_quantity: maximumQuantity
                ? Number(maximumQuantity)
                : null,

            effective_from: effectiveFrom
                ? new Date(effectiveFrom).toISOString()
                : null,

            effective_to: effectiveTo
                ? new Date(effectiveTo).toISOString()
                : null,

            priority: Number(priority),
            is_active: enabled === "Yes",
        };

        await axios
            .put(
                `${baseURL}vehicle-rates/${location.state}`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                    withCredentials: false,
                }
            )
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error updating vehicle rates:",
                    error
                );
            });
    };

    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">
                <div className="bg-white rounded-md p-4">
                    <h2 className="text-lg font-semibold mb-6">
                        Edit Vehicle Rate
                    </h2>

                    <form onSubmit={handleSubmit}>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Pricing Profile *
                                </label>
                                <select
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={pricingProfileId}
                                    onChange={(e) =>
                                        setPricingProfileId(e.target.value)
                                    }
                                >
                                    {pricingProfiles.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Vehicle Type *
                                </label>
                                <select
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={vehicleTypeId}
                                    onChange={(e) =>
                                        setVehicleTypeId(e.target.value)
                                    }
                                >
                                    {vehicleTypes.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>


                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Season
                                </label>
                                <select
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={seasonId}
                                    onChange={(e) =>
                                        setSeasonId(e.target.value)
                                    }
                                >
                                    <option value="">
                                        Default Rate
                                    </option>
                                    {seasons.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Rate Unit *
                                </label>
                                <select
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={rateUnitId}
                                    onChange={(e) =>
                                        setRateUnitId(e.target.value)
                                    }
                                >
                                    {rateUnits.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.code}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Amount *
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={amount}
                                    onChange={(e) =>
                                        setAmount(e.target.value)
                                    }
                                    required
                                />
                            </div>
                        </div>


                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">


                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Minimum Quantity
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={minimumQuantity}
                                    onChange={(e) =>
                                        setMinimumQuantity(
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Maximum Quantity
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={maximumQuantity}
                                    onChange={(e) =>
                                        setMaximumQuantity(
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                        </div>


                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Effective From
                                </label>
                                <CustomFormatDatePicker
                                    value={effectiveFrom}
                                    onChange={setEffectiveFrom}
                                    required={true}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Effective To
                                </label>
                                <CustomFormatDatePicker
                                    value={effectiveTo}
                                    onChange={setEffectiveTo}
                                    minDate={effectiveFrom}
                                    required={true}
                                />
                            </div>
                        </div>


                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Priority
                                </label>
                                <input
                                    type="number"
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={priority}
                                    onChange={(e) =>
                                        setPriority(e.target.value)
                                    }
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                    Active
                                </label>
                                <select
                                    className="w-full h-12 px-4 border rounded-md"
                                    value={enabled}
                                    onChange={(e) =>
                                        setEnabled(e.target.value)
                                    }
                                >
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <button
                                type="submit"
                                className="px-5 py-2 bg-primary text-white rounded"
                            >
                                Save
                            </button>

                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="px-5 py-2 border border-primary text-primary rounded"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    );
};